import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { PossibleNaviationPages } from "../components/Navigation";
import { apiCallBegan } from "./api";
import {
  BROKER,
  FormProperties,
  PossibleArrayTypesForFormGroupNodeArray,
} from "./businesslogic/hardwiredlogic";
import { generateClientDetailsFromFormstateAndPermanentCodeDetails } from "./businesslogic/hwlHelper";
import { PossibleApiStatusValues } from "./helperfuncs";
import download from "downloadjs";
import { components } from "react-select";

//#region Helper Functions
const initializeNaviationPages = () => {
  let returnValue = {};
  for (let pagecode in PossibleNaviationPages) {
    returnValue[PossibleNaviationPages[pagecode]] = false;
  }

  return returnValue;
};

const createFormsGroupsNodesArrayAndInitializeFormstate = ({
  formsorder,
  formstate,
}) => {
  let formsGroupsNodesArray = [];
  formsorder.forEach((formid) => {
    let { type } = formstate[formid];
    formsGroupsNodesArray = [
      ...formsGroupsNodesArray,
      ...FormProperties({
        formtype: type,
      }).convertFormStateToFormGroupNodesArray({
        formstate: formstate[formid],
      }),
    ];

    // TODO: do not push if there are no questions answered
    // if all the questions under form or group is unanswered do not push
  });

  // determine if the the formGroupsNodesArray is having the last and the first group

  //convert the array to object with the key as an object
  let fgmObject = {};
  formsGroupsNodesArray.forEach((item, index) => {
    fgmObject[index] = { ...item };
  });

  let nodecount = 0;
  formsGroupsNodesArray.forEach((item, index) => {
    if (item.type === PossibleArrayTypesForFormGroupNodeArray.node) {
      if (nodecount === 0) {
        fgmObject[index].firstnode = true;
      }
      if (nodecount > 0) {
        fgmObject[index].middlenode = true;
      }
      if (formsGroupsNodesArray.length === index + 1)
        fgmObject[index].lastnode = true;

      nodecount++;
      fgmObject[index].nodecount = nodecount;
    }
    if (item.type !== PossibleArrayTypesForFormGroupNodeArray.node) {
      if (nodecount > 0) {
        nodecount = 0;
        /// this means the previous node is the last node
        fgmObject[index - 1].lastnode = true;
      }
    }
  });

  for (let index in fgmObject) {
    formsGroupsNodesArray[index] = fgmObject[index];
  }

  return formsGroupsNodesArray;
};

// const givePageProperties = ({componentSizeObject, availablePageHeight, pageNumber, pageProperties, indexToStartWith})=>{

//   let additionOfSizes = 0;
//   if(indexToStartWith in componentSizeObject){
//     if(additionOfSizes<availablePageHeight && )
//   }

// }

const pagePropertiesAsPerForms = ({
  formGroupNodesArray,
  formGroupNodesSizeObject,
  availablePageHeight,
}) => {
  let formindex = 0;
  let formObjectWithDetailPages = {};
  let sizeobjectindex = 0;
  for (let index in formGroupNodesArray) {
    if (
      formGroupNodesArray[index].type ===
      PossibleArrayTypesForFormGroupNodeArray.form
    ) {
      sizeobjectindex = 0;
      formindex++;
      formObjectWithDetailPages[formindex] = {};
    }

    formObjectWithDetailPages[formindex][sizeobjectindex] =
      formGroupNodesSizeObject[index];

    sizeobjectindex++;
  }

  // NOW AGGREATATE INDIVIDUAL FORM PAGES

  let mainPageDistribution = {};
  for (let formNumbers in formObjectWithDetailPages) {
    let pageDistribution = givePageProperties({
      componentSizeObject: formObjectWithDetailPages[formNumbers],
      availablePageHeight,
    });

    for (let pageNumber in pageDistribution) {
      mainPageDistribution[Object.keys(mainPageDistribution).length + 1] =
        pageDistribution[pageNumber];
    }
  }

  let mainPageDistributionUniversal = {};
  mainPageDistributionUniversal[1] = mainPageDistribution[1];

  for (let pagenumber in mainPageDistribution) {
    pagenumber = Number(pagenumber);
    if (mainPageDistribution[pagenumber + 1]) {
      mainPageDistributionUniversal[pagenumber + 1] = {};
      mainPageDistributionUniversal[pagenumber + 1].start =
        mainPageDistributionUniversal[pagenumber].end + 1;
      let difference =
        mainPageDistributionUniversal[pagenumber + 1].start -
        mainPageDistribution[pagenumber + 1].start;
      mainPageDistributionUniversal[pagenumber + 1].end =
        mainPageDistribution[pagenumber + 1].end + difference;
    }
  }

  return mainPageDistributionUniversal;
};

const givePageProperties = ({ componentSizeObject, availablePageHeight }) => {
  let pageNumber = 1;
  let pageProperties = { 1: { start: 0 } };
  let additionOfSizes = 0;
  let indexObject = 0;
  for (let index in componentSizeObject) {
    index = Number(index);
    additionOfSizes += componentSizeObject[index];
    indexObject = index;
    if (additionOfSizes >= availablePageHeight) {
      additionOfSizes = componentSizeObject[index];
      pageProperties[pageNumber].end = index - 1;
      pageNumber++;
      pageProperties[pageNumber] = { start: index };
    }
  }

  pageProperties[pageNumber].end = indexObject;

  return pageProperties;
};

//#endregion

const slice = createSlice({
  name: "components",
  initialState: {
    isLoginModalOpen: false,
    isSignUpModalOpen: false,
    isConformationModalOpen: false,
    isBugModalOpen: false,
    isSuccessStatusModalOpen: false, // change this after styling modal
    isErrorStatusModalOpen: false,
    isBindModalOpen: false,
    isBindQuoteConformationModalOpen: false,
    isBinderLetterModalOpen: false,
    isCertificateModalOpen: false,
    isCreateReminderModalOpen: false,
    isOtherStatusModalOpen: false,
    // isCertificateData: {},
    isCertificateHolderModalOpen: false,
    isAdditionalModalOpen: false,
    isTransactionModalOpen: false,
    isReminderModalOpen: false,
    isAddressModalOpen: false,
    isDnDModalOpen: false,
    isClientHandOffModalOpen: false,
    showHelpOrTip: true,
    isgoToMarket: false,
    helpOrTipText: "",
    languagecode: "en",
    showRecentQuotesTable: true,
    questionFlowUserMode: BROKER,
    qAreaScrollThickness: false,
    navigationActivation: initializeNaviationPages(),
    recentquotes: PossibleApiStatusValues.notstarted,
    jira: PossibleApiStatusValues.notstarted,
    dataforInsurerView: PossibleApiStatusValues.notstarted,
    doNotShowNavigationButtons: false,
    showNavigationBar: true,
    doc: PossibleApiStatusValues.notstarted,
    formstate: null,
    formsorder: null,
    formGroupNodesArray: null,
    formGroupNodesSizeObject: {},
    showActualSTIpdf: false,
    pages: {},
    clientDetails: {},
    userdetails: null,
    brokerdetails: null,
    gettingPdf: PossibleApiStatusValues.notstarted,
    gettingPdfv2: PossibleApiStatusValues.notstarted,
    gettingClientPdf: PossibleApiStatusValues.notstarted,
    gettingBindLetterPdf: PossibleApiStatusValues.notstarted,
    gettingBindPdf: PossibleApiStatusValues.notstarted,
    gettingBindExternal: PossibleApiStatusValues.notstarted,
    currentblobcontent: null,
    gettingPdfOnly: PossibleApiStatusValues.notstarted,
    quoteyUpdates: [],
    autoreminder: {},
  },

  reducers: {
    // action => action handler
    goToMarket: (components, action) => {
      if (action.payload == false) {
        components.isgoToMarket = false;
      } else {
        components.isgoToMarket = true;
      }
    },
    resetBinderPdf: (components, action) => {
      components.gettingBindPdf = PossibleApiStatusValues.notstarted;
    },
    loginModalOpened: (components, action) => {
      components.isLoginModalOpen = true;
      components.showHelpOrTip = false;
    },
    loginModalClosed: (components, action) => {
      components.isLoginModalOpen = false;
      components.showHelpOrTip = true;
    },
    signUpModalOpened: (components, action) => {
      components.isSignUpModalOpen = true;
      components.showHelpOrTip = false;
    },
    signUpModalClosed: (components, action) => {
      components.isSignUpModalOpen = false;
      components.showHelpOrTip = true;
    },
    conformationModalOpened: (components, action) => {
      components.isConformationModalOpen = true;
      components.showHelpOrTip = false;
    },
    conformationModalClosed: (components, action) => {
      components.isConformationModalOpen = false;
      components.showHelpOrTip = true;
    },
    bugModalOpened: (components, action) => {
      components.isBugModalOpen = true;
    },

    bugModalClosed: (components, action) => {
      components.isBugModalOpen = false;
    },

    successStatusModalOpened: (components, action) => {
      components.isSuccessStatusModalOpen = true;
    },

    successStatusModalClosed: (components, action) => {
      components.isSuccessStatusModalOpen = false;
    },

    errorStatusModalOpened: (components, action) => {
      components.isErrorStatusModalOpen = true;
    },

    errorStatusModalClosed: (components, action) => {
      components.isErrorStatusModalOpen = false;
    },

    addressModalOpened: (components, action) => {
      components.isAddressModalOpen = true;
    },

    addressModalClosed: (components, action) => {
      components.isAddressModalOpen = true;
    },

    bindModalOpened: (components, action) => {
      components.isBindModalOpen = true;
    },
    bindModalClosed: (components, action) => {
      components.isBindModalOpen = false;
    },

    openBindQuoteConformationModal: (components, action) => {
      components.isBindQuoteConformationModalOpen = true;
    },
    closeBindQuoteConformationModal: (components, action) => {
      components.isBindQuoteConformationModalOpen = false;
    },

    binderLetterModalOpened: (components, action) => {
      components.isBinderLetterModalOpen = action.payload
        ? action.payload
        : true;
    },
    binderLetterModalClosed: (components, action) => {
      components.isBinderLetterModalOpen = false;
    },
    certificateModalOpened: (components, action) => {
      components.isCertificateModalOpen = true;
    },
    certificateModalClosed: (components, action) => {
      components.isCertificateModalOpen = false;
    },
    reminderModalOpenedv: (components, action) => {
      components.isCreateReminderModalOpen = true;
    },
    reminderOtherStatusOpened: (components, action) => {
      components.isOtherStatusModalOpen = true;
    },
    reminderOtherStatusClosed: (components, action) => {
      components.isOtherStatusModalOpen = false;
    },
    reminderModalClosedv: (components, action) => {
      components.isCreateReminderModalOpen = false;
    },
    setautoreminder: (components, action) => {
      components.autoreminder = {
        ...action.payload,
      };
    },
    certificateHolderModalOpened: (components, action) => {
      components.isCertificateHolderModalOpen = true;
    },
    certificateHolderModalClosed: (components, action) => {
      components.isCertificateHolderModalOpen = false;
    },
    additionalModalOpened: (components, action) => {
      components.isAdditionalModalOpen = true;
    },
    additionalModalClosed: (components, action) => {
      components.isAdditionalModalOpen = false;
    },
    transactionModalOpened: (components, action) => {
      components.isTransactionModalOpen = true;
    },
    transactionModalClosed: (components, action) => {
      components.isTransactionModalOpen = false;
    },
    reminderModalOpened: (components, action) => {
      components.isReminderModalOpen = true;
    },
    reminderModalClosed: (components, action) => {
      components.isReminderModalOpen = false;
    },
    reminderModalSet: (components, action) => {
      components.isReminderModalOpen = action.payload;
    },
    dndModalOpened: (components, action) => {
      components.isDnDModalOpen = true;
      components.showHelpOrTip = false;
    },

    dndModalClosed: (components, action) => {
      components.isDnDModalOpen = false;
      components.showHelpOrTip = true;
    },

    clientHandOffModalOpened: (components, action) => {
      components.isClientHandOffModalOpen = true;
    },

    clientHandOffModalClosed: (components, action) => {
      components.isClientHandOffModalOpen = false;
    },

    helpOrTipShowed: (components, action) => {
      components.showHelpOrTip = true;
    },

    helpOrTipHidden: (components, action) => {
      components.showHelpOrTip = false;
    },

    changeHelpOrTipText: (components, action) => {
      components.helpOrTipText = action.payload;
    },

    changeLanguageCode: (components, action) => {
      components.languagecode = action.payload;
    },

    changeShowRecentQuotesTable: (components, action) => {
      components.showRecentQuotesTable = action.payload;
    },

    changeQuestionFlowUserMode: (components, action) => {
      components.questionFlowUserMode = action.payload;
    },

    changeQAreaScrollThickness: (components, action) => {
      components.qAreaScrollThickness = action.payload;
    },

    activateNavigationPage: (components, action) => {
      let pagecodeRequested = action.payload.pagecode;
      for (let pagecode in components.navigationActivation) {
        if (pagecode === pagecodeRequested)
          components.navigationActivation[pagecode] = true;
        else components.navigationActivation[pagecode] = false;
      }
    },

    recentQuotesInitiated: (components, action) => {
      components.recentquotes = PossibleApiStatusValues.loading;
    },
    recentQuotesFailed: (components, action) => {
      components.recentquotes = PossibleApiStatusValues.failed;
    },
    recentQuotesSuccess: (components, action) => {
      components.recentquotes = action.payload.recentquotes;
    },
    quoteyUpdatesSuccess: (components, action) => {
      components.quoteyUpdates = action.payload;
    },
    quoteyUpdatesFailed: (components, action) => {
      components.quoteyUpdates = [];
    },

    // For Jira (onStart, onSuccess, onError)
    recentJiraInitiated: (components, action) => {
      components.jira = PossibleApiStatusValues.loading;
    },
    recentJiraFailed: (components, action) => {
      components.jira = PossibleApiStatusValues.failed;
    },
    recentJiraSuccess: (components, action) => {
      // components.jira = action.payload;
      components.jira = PossibleApiStatusValues.success;
    },

    changeDoNotShowNavigationButtons: (components, action) => {
      components.doNotShowNavigationButtons = action.payload.value;
    },

    dataForInsurerViewInitialized: (components, action) => {
      components.dataforInsurerView = PossibleApiStatusValues.loading;
    },

    dataForInsurerViewFailed: (components, action) => {
      components.dataforInsurerView = PossibleApiStatusValues.failed;
    },
    dataForInsurerViewSuccess: (components, action) => {
      components.dataforInsurerView = action.payload.data;
    },
    changeShowNavigationBar: (components, action) => {
      components.showNavigationBar = action.payload.value;
    },
    dataForStiPDFreadyInitialized: (components, action) => {
      components.doc = PossibleApiStatusValues.loading;
    },

    dataForStiPDFreadyFailed: (components, action) => {
      components.doc = PossibleApiStatusValues.failed;
    },
    dataForStiPDFreadySuccess: (components, action) => {
      components.doc = action.payload.prospectdoc;
      components.userdetails = action.payload.userdetails;
      components.brokerdetails = action.payload.brokerdetails;
      let formstate = action.payload.prospectdoc.formstate;
      let formsorder = action.payload.prospectdoc.formsorder;
      components.formsorder = formsorder;
      components.formstate = formstate;
      components.formGroupNodesArray =
        createFormsGroupsNodesArrayAndInitializeFormstate({
          formsorder,
          formstate,
        });
      let permanentcodedetails =
        action.payload.prospectdoc.permanentcodedetails;
      components.clientDetails =
        generateClientDetailsFromFormstateAndPermanentCodeDetails({
          permanentcodedetails,
          formstate,
        });
    },

    updateFormstateSize: (components, action) => {
      let { type, formstateAddress, scrollHeight, index } = action.payload;
      components.formGroupNodesSizeObject[index] = scrollHeight;
      if (type === PossibleArrayTypesForFormGroupNodeArray.form)
        components.formstate[formstateAddress.formid].size = scrollHeight;
      if (type === PossibleArrayTypesForFormGroupNodeArray.node)
        components.formstate[formstateAddress.formid].nodestate[
          formstateAddress.nodeid
        ].size = scrollHeight;
      if (type === PossibleArrayTypesForFormGroupNodeArray.group)
        components.formstate[formstateAddress.formid].groupstate[
          formstateAddress.groupid
        ].size = scrollHeight;
      if (type === PossibleArrayTypesForFormGroupNodeArray.location)
        components.formstate[formstateAddress.formid].locationstate[
          formstateAddress.locationid
        ].size = scrollHeight;
      if (type === PossibleArrayTypesForFormGroupNodeArray.locationgroup)
        components.formstate[formstateAddress.formid].locationstate[
          formstateAddress.locationid
        ].groupstate[formstateAddress.groupid].size = scrollHeight;
    },

    changeShowActualSTIpdfAndReadyPages: (components, action) => {
      //calculate the pages
      components.pages = pagePropertiesAsPerForms({
        formGroupNodesArray: components.formGroupNodesArray,
        formGroupNodesSizeObject: components.formGroupNodesSizeObject,
        availablePageHeight: action.payload.availablePageSize,
      });

      components.showActualSTIpdf = action.payload.value;
    },

    gettingPDFInitialized: (components, action) => {
      components.gettingPdf = PossibleApiStatusValues.loading;
    },
    gettingPDFFailed: (components, action) => {
      components.gettingPdf = PossibleApiStatusValues.failed;
    },
    gettingPDFSuccess: (components, action) => {
      components.gettingPdf = URL.createObjectURL(action.payload.response);
      components.currentblobcontent =
        action.payload.fullresponse.headers["content-type"];
      download(
        action.payload.response,
        components.languagecode === "fr" ? "Assureur_Proposition d'assurance pour soumission" : "Client_Details",
        action.payload.fullresponse.headers["content-type"]
      );
    },

    gettingPDFV2Initialized: (components, action) => {
      components.gettingPdfv2 = PossibleApiStatusValues.loading;
    },

    gettingONLYPDFV2Initialized: (components, action) => {
      components.gettingPdfOnly = PossibleApiStatusValues.loading;
    },

    gettingClientPDFInitialized: (components, action) => {
      components.gettingClientPdf = PossibleApiStatusValues.loading;
    },

    gettingBinderLetterInitialized: (components, action) => {
      components.gettingBindLetterPdf = PossibleApiStatusValues.loading;
    },

    gettingBinderPdfInitialized: (components, action) => {
      components.gettingBindPdf = PossibleApiStatusValues.loading;
    },

    gettingBinderExternalInitialized: (components, action) => {
      components.gettingBindExternal = PossibleApiStatusValues.loading;
    },
    gettingBinderExternalSuceess: (components, action) => {
      components.gettingBindExternal = action.payload;
    },
    gettingBinderExternalFailed: (components, action) => {
      components.gettingBindExternal = PossibleApiStatusValues.failed;
    },
    resetBindExternal: (components, action) => {
      components.gettingBindExternal = PossibleApiStatusValues.notstarted;
    },
    gettingPDFV2Failed: (components, action) => {
      components.gettingPdfv2 = PossibleApiStatusValues.failed;
    },

    gettingBinderPdfFailed: (components, action) => {
      components.gettingBindPdf = PossibleApiStatusValues.failed;
    },

    gettingONLYPDFV2Failed: (components, action) => {
      components.gettingPdfOnly = PossibleApiStatusValues.failed;
    },

    gettingClientPDFFailed: (components, action) => {
      components.gettingClientPdf = PossibleApiStatusValues.failed;
    },

    gettingBinderLetterFailed: (components, action) => {
      components.gettingBindLetterPdf = PossibleApiStatusValues.failed;
    },

    gettingPDFV2Success: (components, action) => {
      const lang = action.payload.extras?.pdf_language_selected || components.languagecode;
      const clientName = (action.payload.extras?.client_name || "").replace(/\./g, "").replace(/[\/\\:*?"<>|]/g, " ").replace(/\s+/g, " ").trim();
      const {
        downloadingEml,
        mailto,
        bcc,
        body,
        subject,
        additionalDocuments: additionalDocsMetadataFromExtras, // Metadata from original call
      } = action.payload.extras;
    
      const serverResponse = action.payload.response; // This is a Blob OR an array of Base64 strings
      const fullResponseHeaders = action.payload.fullresponse?.headers;
    
      const EOL = "\r\n";
      const boundary = "Boundary_MIME_Frontend_" + Date.now().toString(36);
      const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
          if (!(blob instanceof Blob)) {
            return reject(new Error("blobToBase64: Expected a Blob."));
          }
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result;
            if (typeof result === 'string' && result.includes(',')) {
              resolve(result.split(',')[1]);
            } else {
              reject(new Error("blobToBase64: FileReader did not return a valid data URL."));
            }
          };
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(blob);
        });
      };
    
      const stringUtf8ToBase64 = (str) => {
        try {
          const bytes = new TextEncoder().encode(str);
          let binary = '';
          bytes.forEach(byte => binary += String.fromCharCode(byte));
          return btoa(binary);
        } catch (e) {
          // Fallback for older environments or unexpected input
          return btoa(unescape(encodeURIComponent(String(str))));
        }
      };
    
      const foldBase64 = (rawBase64) => {
        let folded = "";
        for (let i = 0; i < rawBase64.length; i += 76) {
          folded += rawBase64.substring(i, Math.min(i + 76, rawBase64.length));
          if (i + 76 < rawBase64.length) {
            folded += EOL;
          }
        }
        return folded;
      };

      const quotedPrintableEncode = (str) => {
        return str.replace(/[^ -~]/g, // Match non-printable ASCII, and non-ASCII
          (match) => {
            const hex = match.charCodeAt(0).toString(16).toUpperCase();
            return '=' + (hex.length < 2 ? '0' : '') + hex;
          }
        ).replace(/ $/gm, '=20') // Encode trailing spaces
         .replace(/\t$/gm, '=09'); // Encode trailing tabs
        // For robust QP, you'd also handle line length limits (usually 76 chars including "=CRLF")
        // and soft line breaks (= at end of line). For simplicity, we are not doing full line folding here for QP.
      };

      const encodeHeaderField = (value) => {
        if (!value) return "";
        if (/[^\x00-\x7F]/.test(value)) { // Check if non-ASCII characters are present
            const utf8Bytes = new TextEncoder().encode(value);
            const binaryString = String.fromCharCode(...utf8Bytes);
            const base64Encoded = btoa(binaryString);
            return `=?utf-8?B?${base64Encoded}?=`; // RFC 2047 "encoded-word"
        }
        return value; // Return as-is if only ASCII
    };
    
    const constructAndDownloadEml = (attachmentsArray) => {
      const boundary = "----MIME_Boundary_Simple_Mixed_" + Date.now().toString(16);
  
      let emlContent = `To: ${mailto || ""}${EOL}`;
      if (bcc && bcc.trim() !== "") {
          emlContent += `Bcc: ${bcc}${EOL}`;
      }
      emlContent += `Subject: ${encodeHeaderField(subject || "")}${EOL}`;
      emlContent += `X-Unsent: 1${EOL}`;
      emlContent += `MIME-Version: 1.0${EOL}`;
      emlContent += `Content-Type: multipart/mixed; boundary="${boundary}"${EOL}`;
      emlContent += EOL; // Blank line after main headers
  
      // --- Email HTML body part ---
      emlContent += `--${boundary}${EOL}`;
      emlContent += `Content-Type: text/html; charset=utf-8${EOL}`;
      emlContent += `Content-Transfer-Encoding: base64${EOL}`;
      emlContent += EOL; // Blank line separating headers from content
  
   
      const rawBodyText = body || ""; // Use the body from payload, fallback to empty string
  
      
      const escapedBodyText = rawBodyText.replace(/&/g, '&')
                                       .replace(/</g, '<')
                                       .replace(/>/g, '>')
                                       .replace(/"/g, '"')
                                      
  
      
      const htmlBodyContent = `<pre style="font-family: Calibri, Arial, sans-serif; font-size: 11pt; white-space: pre-wrap; word-wrap: break-word;">${escapedBodyText}</pre>`;
  
  
      emlContent += foldBase64(stringUtf8ToBase64(htmlBodyContent));
      // NO explicit EOL needed here; the next boundary or final boundary will be prefixed with EOL.
  
      // --- Attachment parts ---
      if (attachmentsArray && attachmentsArray.length > 0) {
          attachmentsArray.forEach(att => {
              emlContent += `${EOL}--${boundary}${EOL}`;
              emlContent += `Content-Type: ${att.type}; name="${encodeHeaderField(att.fileName)}"${EOL}`;
              emlContent += `Content-Transfer-Encoding: base64${EOL}`;
              emlContent += `Content-Disposition: attachment; filename="${encodeHeaderField(att.fileName)}"${EOL}`;
              emlContent += EOL;
              emlContent += foldBase64(att.base64);
          });
      }
  
      emlContent += `${EOL}--${boundary}--${EOL}`;
  
    
  
      if (typeof download === 'function') {
          download(emlContent, "OpenWithOutlook.eml", "message/rfc822");
      } else {
          // Fallback download
          console.error("'download' function is not defined. Using fallback.");
          const blobFile = new Blob([emlContent], { type: "message/rfc822" });
          const url = URL.createObjectURL(blobFile);
          const a = document.createElement("a");
          a.href = url;
          a.download = "OpenWithOutlook.eml";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
      }
  };
    
      if (downloadingEml) {
        components.gettingPdfv2 = PossibleApiStatusValues.success;
        let attachmentsPromise;

        if (Array.isArray(serverResponse)) {
          // Server responded with an array of Base64 strings
          // [mainPdfBase64, additionalDoc1Base64, additionalDoc2Base64, ...]
          const finalAttachments = [];
         
          // Main PDF is the first item in the serverResponse array
          if (serverResponse.length > 0 && typeof serverResponse[0] === 'string') {
            finalAttachments.push({
              base64: serverResponse[0],
              type: "application/pdf",
              fileName: lang === "fr" ? `Soumission d'assurance pour ${clientName}.pdf` : `Insurance submission for ${clientName}.pdf`,
            });
          } else {
            return Promise.reject(new Error("Main PDF Base64 string missing from server array response."));
          }
    
          // Additional documents from the server array, using metadata from `additionalDocsMetadataFromExtras`
          // This assumes `additionalDocsMetadataFromExtras` items correspond to serverResponse[1], serverResponse[2], ...
          
          if (additionalDocsMetadataFromExtras) {
            additionalDocsMetadataFromExtras.forEach((docMeta, index) => {
              const base64DataFromServer = serverResponse[index + 1]; // +1 to skip main PDF
              if (base64DataFromServer && typeof base64DataFromServer === 'string') {
                finalAttachments.push({
                  base64: base64DataFromServer,
                  type: docMeta.type, // From the metadata passed in extras
                  fileName: docMeta.fileName // From the metadata passed in extras
                });
              } else {
                console.warn(`Missing or invalid Base64 data from server for additional document: ${docMeta.fileName}`);
              }
            });
          }
          attachmentsPromise = Promise.resolve(finalAttachments);
    
        } else if (serverResponse instanceof Blob) {
          // Server responded with a single Blob (the main PDF)
          const itemsToProcessForBase64 = [];
          itemsToProcessForBase64.push({
            blob: serverResponse, // This is the main PDF blob
            type: "application/pdf",
            fileName: lang === "fr" ? `Soumission d'assurance pour ${clientName}.pdf` : `Insurance submission for ${clientName}.pdf`,
          });

          // Check for any *client-side* additional documents to attach
          // These would need their `fileBlob` property in `additionalDocsMetadataFromExtras`
          if (additionalDocsMetadataFromExtras) {
            additionalDocsMetadataFromExtras.forEach(docMeta => {
              // The key here is `docMeta.fileBlob` which you said is in your payload.
              // That means the Blob for this additional document is already available on the client.
              if (docMeta.fileBlob instanceof Blob && docMeta.type && docMeta.fileName) {
                itemsToProcessForBase64.push({
                  blob: docMeta.fileBlob,
                  type: docMeta.type,
                  fileName: docMeta.fileName
                });
              } else if (docMeta.s3Upload && docMeta.type && docMeta.fileName) {
              
                console.warn(`Additional document ${docMeta.fileName} has S3 info but no local fileBlob. This scenario requires fetching from S3 on client if not handled by server array response.`);
              }
            });
          }
          attachmentsPromise = Promise.all(
            itemsToProcessForBase64.map(item =>
              blobToBase64(item.blob).then(b64 => ({
                base64: b64,
                type: item.type,
                fileName: item.fileName
              }))
            )
          );
        } else {
          attachmentsPromise = Promise.reject(new Error("Invalid server response type."));
        }
    
        attachmentsPromise
          .then(finalAttachmentsArray => {
            if (!finalAttachmentsArray || finalAttachmentsArray.length === 0) {
              console.error("No attachments to include in EML.");
              // dispatch failure
              return;
            }
            console.log('attachment check',finalAttachmentsArray)
            constructAndDownloadEml(finalAttachmentsArray);
          })
          .catch(error => {
            console.error("Error preparing EML attachments:", error);
            // dispatch failure
          });
    
      } else { // Direct download (serverResponse must be a Blob)
        components.gettingPdfOnly = PossibleApiStatusValues.success;
        if (serverResponse instanceof Blob) {
          const contentTypeHeader = fullResponseHeaders?.["content-type"];
          const fileMimeType = contentTypeHeader || serverResponse.type || "application/octet-stream";
          let fileName = lang === "fr" ? `Soumission d'assurance pour ${clientName}` : `Insurance submission for ${clientName}`;
          const disposition = fullResponseHeaders?.["content-disposition"];
          if (disposition) {
            const filenameMatch = disposition.match(/filename\*?=(?:UTF-\d['"]*)?([^;\r\n"']+)(?:["']|$)/i);
            if (filenameMatch && filenameMatch[1]) {
              try { fileName = decodeURIComponent(filenameMatch[1].replace(/^['"]|['"]$/g, '')); }
              catch (e) { fileName = filenameMatch[1].replace(/^['"]|['"]$/g, ''); }
            }
          }
          if (!/\.\w{2,4}$/.test(fileName)) {
            if (fileMimeType === "application/pdf") fileName += ".pdf";
            else if (fileMimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") fileName += ".xlsx";
            // Add more types as needed
          }
          download(serverResponse, fileName, fileMimeType);
        } else {
          console.error("Error: Expected a Blob for direct download, but received:", typeof serverResponse);
          // dispatch failure
        }
      }
    },
    

    gettingClientPDFSuccess: (components, action) => {
      const lang = action.payload.extras?.pdf_language_selected || components.languagecode;
      const clientName = (action.payload.extras?.client_name || "").replace(/\./g, "").replace(/[\/\\:*?"<>|]/g, " ").replace(/\s+/g, " ").trim();
      let downloadingEml = action.payload.extras.downloadingEml;

      // TODO: Change the email content when data is finalized
      if (downloadingEml) {
        components.gettingClientPdf = PossibleApiStatusValues.success;
        let bcc = action.payload.extras.bcc;
        let body = action.payload.extras.body;
        let subject = action.payload.extras.subject;
        let mailto = action.payload.extras.mailto;
        let reader = new FileReader();
        reader.readAsDataURL(action.payload.response);
        reader.onloadend = function () {
          var base64data = reader.result.split(",")[1];

          // console.log(base64data);

          /////////////////// EML FILE LOGIC///////////

          // let emlContent = "data:message/rfc822 eml;charset=utf-8,";
          let emlContent = "To: " + mailto + "\n";
          emlContent += "bcc: " + bcc + "\n";
          emlContent += `Subject: ${subject}\n`;
          emlContent += "X-Unsent: 1\n";
          emlContent +=
            "Content-Type: multipart/mixed; boundary=0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent += "Mime-Version: 1.0\n";

          emlContent +=
            "\n--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent +=
            `Content-Type: application/pdf; name=${lang === "fr" ? `Proposition d'assurance pour ${clientName}` : `Insurance proposal for ${clientName}`}.pdf\n`;
          emlContent += "Content-Transfer-Encoding: base64\n";
          emlContent += "Content-Disposition: attachment\n\n";

          emlContent += base64data + "\n\n";
          emlContent +=
            "--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";

          emlContent += body;

          const emlBlob = new Blob([emlContent], { type: "message/rfc822;charset=utf-8" });
          download(emlBlob, "OpenWithOutlook.eml", "message/rfc822");
        };
      } else {
        components.gettingClientPdf = PossibleApiStatusValues.success;
        components.currentblobcontent =
          action.payload.fullresponse.headers["content-type"];
        download(
          action.payload.response,
          lang === "fr" ? `Proposition d'assurance pour ${clientName}` : `Insurance proposal for ${clientName}`,
          action.payload.fullresponse.headers["content-type"]
        );
      }
    },

    gettingBinderLetterPDFSuccess: (components, action) => {
      let downloadingEml = action.payload.extras.downloadingEml;
      let binderid = action.payload.extras.binderid;

      // TODO: Change the email content when data is finalized
      if (downloadingEml) {
        components.gettingBindLetterPdf = PossibleApiStatusValues.success;
        let bcc = action.payload.extras.bcc;
        let body = action.payload.extras.body;
        let subject = action.payload.extras.subject;
        let mailto = action.payload.extras.mailto;
        let reader = new FileReader();
        reader.readAsDataURL(action.payload.response);
        reader.onloadend = function () {
          var base64data = reader.result.split(",")[1];

          // console.log(base64data);

          /////////////////// EML FILE LOGIC///////////

          // let emlContent = "data:message/rfc822 eml;charset=utf-8,";
          let emlContent = "To: " + mailto + "\n";
          emlContent += "bcc: " + bcc + "\n";
          emlContent += `Subject: ${subject}\n`;
          emlContent += "X-Unsent: 1\n";
          emlContent +=
            "Content-Type: multipart/mixed; boundary=0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent += "Mime-Version: 1.0\n";

          emlContent +=
            "\n--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent +=
            "Content-Type: application/pdf; name=Binder_Details.pdf\n";
          emlContent += "Content-Transfer-Encoding: base64\n";
          emlContent += "Content-Disposition: attachment\n\n";

          emlContent += base64data + "\n\n";
          emlContent +=
            "--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";

          emlContent += body;

          const emlBlob = new Blob([emlContent], { type: "message/rfc822;charset=utf-8" });
          download(emlBlob, "OpenWithOutlook.eml", "message/rfc822");
        };
      } else {
        components.currentblobcontent =
          action.payload.fullresponse.headers["content-type"];
        download(
          action.payload.response,
          "Binder_Letter_" + binderid,
          action.payload.fullresponse.headers["content-type"]
        );
        components.gettingBindLetterPdf = PossibleApiStatusValues.success;
      }
    },

    gettingBinderPdfSuceess: (components, action) => {
      let downloadingEml = action.payload.extras.downloadingEml;

      // TODO: Change the email content when data is finalized
      if (downloadingEml) {
        components.gettingClientPdf = PossibleApiStatusValues.success;
        let bcc = action.payload.extras.bcc;
        let body = action.payload.extras.body;
        let subject = action.payload.extras.subject;
        let mailto = action.payload.extras.mailto;
        let reader = new FileReader();
        reader.readAsDataURL(action.payload.response);
        reader.onloadend = function () {
          var base64data = reader.result.split(",")[1];

          // console.log(base64data);

          /////////////////// EML FILE LOGIC///////////

          // let emlContent = "data:message/rfc822 eml;charset=utf-8,";
          let emlContent = "To: " + mailto + "\n";
          emlContent += "bcc: " + bcc + "\n";
          emlContent += `Subject: ${subject}\n`;
          emlContent += "X-Unsent: 1\n";
          emlContent +=
            "Content-Type: multipart/mixed; boundary=0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent += "Mime-Version: 1.0\n";

          emlContent +=
            "\n--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent +=
            "Content-Type: application/pdf; name=BinderDetails.pdf\n";
          emlContent += "Content-Transfer-Encoding: base64\n";
          emlContent += "Content-Disposition: attachment\n\n";

          emlContent += base64data + "\n\n";
          emlContent +=
            "--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";

          emlContent += body;

          const emlBlob = new Blob([emlContent], { type: "message/rfc822;charset=utf-8" });
          download(emlBlob, "OpenWithOutlook.eml", "message/rfc822");
        };
      } else {
        components.gettingBindPdf = PossibleApiStatusValues.success;
        components.currentblobcontent =
          action.payload.fullresponse.headers["content-type"];
        download(
          action.payload.response,
          "Binder",
          action.payload.fullresponse.headers["content-type"]
        );
      }
    },
  },
});

export const {
  goToMarket,
  loginModalOpened,
  loginModalClosed,
  signUpModalOpened,
  signUpModalClosed,
  conformationModalOpened,
  conformationModalClosed,
  bugModalOpened,
  bugModalClosed,
  successStatusModalOpened,
  successStatusModalClosed,
  errorStatusModalOpened,
  errorStatusModalClosed,
  additionalModalOpened,
  additionalModalClosed,
  transactionModalOpened,
  transactionModalClosed,
  bindModalOpened,
  bindModalClosed,
  openBindQuoteConformationModal,
  closeBindQuoteConformationModal,
  binderLetterModalClosed,
  binderLetterModalOpened,
  certificateModalOpened,
  certificateModalClosed,
  reminderModalOpened,
  reminderModalClosed,
  reminderModalSet,
  setautoreminder,
  reminderOtherStatusOpened,
  reminderOtherStatusClosed,
  certificateHolderModalOpened,
  certificateHolderModalClosed,
  addressModalOpened,
  addressModalClosed,
  dndModalOpened,
  dndModalClosed,
  clientHandOffModalClosed,
  clientHandOffModalOpened,
  helpOrTipHidden,
  helpOrTipShowed,
  changeHelpOrTipText,
  changeLanguageCode,
  changeShowRecentQuotesTable,
  changeQuestionFlowUserMode,
  changeQAreaScrollThickness,
  activateNavigationPage,
  recentQuotesInitiated,
  recentQuotesSuccess,
  recentQuotesFailed,
  quoteyUpdatesSuccess,
  quoteyUpdatesFailed,
  recentJiraInitiated,
  recentJiraFailed,
  recentJiraSuccess,
  changeDoNotShowNavigationButtons,
  dataForInsurerViewFailed,
  dataForInsurerViewInitialized,
  dataForInsurerViewSuccess,
  changeShowNavigationBar,
  dataForStiPDFreadyFailed,
  dataForStiPDFreadyInitialized,
  dataForStiPDFreadySuccess,
  changeShowActualSTIpdfAndReadyPages,
  updateFormstateSize,
  gettingPDFFailed,
  gettingPDFSuccess,
  gettingPDFInitialized,
  gettingPDFV2Failed,
  gettingONLYPDFV2Failed,
  gettingPDFV2Initialized,
  gettingONLYPDFV2Initialized,
  gettingPDFV2Success,
  gettingClientPDFFailed,
  gettingClientPDFInitialized,
  gettingClientPDFSuccess,
  gettingBinderLetterInitialized,
  gettingBinderLetterFailed,
  gettingBinderLetterPDFSuccess,
  gettingBinderPdfFailed,
  gettingBinderPdfInitialized,
  gettingBinderPdfSuceess,
  gettingBinderExternalInitialized,
  gettingBinderExternalSuceess,
  gettingBinderExternalFailed,
  resetBindExternal,
  resetBinderPdf,
} = slice.actions;

export default slice.reducer;

//+++++++++++++++++++++++ Action Creators

export const getPDFfromURL = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/pdf",
    method: "get",
    data: data,
    onStart: gettingPDFInitialized.type,
    onSuccess: gettingPDFSuccess.type,
    onError: gettingPDFFailed.type,
    considerPayloads: true,
    responseType: "blob",
    params: data,
  });

// getting pdf from Brian's API a.k.a pdfV2
export const getPDFV2fromURL = (data) => {

  const expectedResponseType = 
    (data.additionalDocuments && data.additionalDocuments.length > 0) 
      ? 'json' // Expecting an array of base64 strings from the server
      : 'blob'; // Expecting a single binary file (PDF) from the server

  return apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/pdf/pdfv2",
    method: "post",
    data: data,
    onStart: data.downloadingEml
      ? gettingPDFV2Initialized.type
      : gettingONLYPDFV2Initialized.type,
    onSuccess: gettingPDFV2Success.type,
    onError: data.downloadingEml
      ? gettingPDFV2Failed.type
      : gettingONLYPDFV2Failed.type,
    considerPayloads: true,
    responseType: expectedResponseType, // Use the dynamically determined response type
    onSuccessPayload: {
      downloadingEml: data.downloadingEml,
      mailto: data.mailto,
      bcc: data.bcc,
      body: data.body,
      subject: data.subject,
      additionalDocuments: data.additionalDocuments, // This is metadata for frontend processing
      additionalInfo: data.additionalSTIInfo?.additionalInfo,
      documentsToUpload: data.additionalSTIInfo?.documentsToUpload,
      pdf_language_selected: data.pdf_language_selected,
      client_name: data.client_name,
    },
  });
};

export const getClientPDFfromURL = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/pdf/clientsubmissionpdf",
    method: "post",
    data: data,
    onStart: gettingClientPDFInitialized.type,
    onSuccess: gettingClientPDFSuccess.type,
    onError: gettingClientPDFFailed.type,
    considerPayloads: true,
    responseType: "blob",
    onSuccessPayload: {
      downloadingEml: data.downloadingEml,
      mailto: data.mailto,
      bcc: data.bcc,
      body: data.body,
      subject: data.subject,
      pdf_language_selected: data.pdf_language_selected,
      client_name: data.client_name,
    },
  });

export const getBinderLetterFromURL = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/pdf/binder-letter-pdf",
    method: "post",
    data: data,
    onStart: gettingBinderLetterInitialized.type,
    onSuccess: gettingBinderLetterPDFSuccess.type,
    onError: gettingBinderLetterFailed.type,
    considerPayloads: true,
    responseType: "blob",
    onSuccessPayload: {
      downloadingEml: data.downloadingEml,
      mailto: data.mailto,
      bcc: data.bcc,
      body: data.body,
      subject: data.subject,
      binderid: data.binderid,
    },
  });

export const getBinderPDF = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: `/api/pdf/${data.bindType}`, // bindtype can be bind1 or bind2
    method: "post",
    data: data,
    onStart: gettingBinderPdfInitialized.type,
    onSuccess: data.sendEmailDirectToInsurer
      ? () => {}
      : gettingBinderPdfSuceess.type,
    onError: gettingBinderPdfFailed.type,
    considerPayloads: true,
    responseType: "blob",
    onSuccessPayload: {
      downloadingEml: data.downloadingEml,
      mailto: data.mailto,
      bcc: data.bcc,
      body: data.body,
      subject: data.subject,
    },
  });

export const bindExternalResponse = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: `/api/eic/bind`, // bindtype can be bind1 or bind2
    method: "post",
    data: data,
    onStart: gettingBinderExternalInitialized.type,
    onSuccess: gettingBinderExternalSuceess.type,
    onError: gettingBinderExternalFailed.type,
  });

export const getRecentQuotes = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/gettopuserprospects",
    method: "post",
    data: data,
    onStart: recentQuotesInitiated.type,
    onSuccess: recentQuotesSuccess.type,
    onError: recentQuotesFailed.type,
  });

export const sendChsEmail = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/sendChsEmail",
    method: "post",
    data: data,
    // onStart: recentQuotesInitiated.type,
    // onSuccess: recentQuotesSuccess.type,
    // onError: recentQuotesFailed.type,
  });

export const getQuoteyRecentUpdates = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/updates",
    method: "get",

    onSuccess: quoteyUpdatesSuccess.type,
    onError: quoteyUpdatesFailed.type,
  });

export const addQuoteyUpdate = (updateData) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/updates/add", // Endpoint for adding a new update
    method: "post", // Using 'post' method to add data
    data: updateData, // Data for the new update
    // onStart: addUpdateInitiated.type,
    // onSuccess: addUpdateSuccess.type,
    // onError: addUpdateFailed.type,
  });

export const addQuoteyUpdateMulti = (updateData) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/updates/addMultiple", // Endpoint for adding a new update
    method: "post", // Using 'post' method to add data
    data: updateData, // Data for the new update
  });

export const updateQuoteyUpdate = (id, updateData) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: `/api/updates/${id}`,
    method: "put",
    data: updateData,
    // onStart: quoteyUpdatesRequested.type,
    // onSuccess: updateQuoteyUpdateSuccess.type,
    // onError: quoteyUpdatesFailed.type,
  });

export const deleteQuoteyUpdate = (id) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: `/api/updates/${id}`,
    method: "delete",
    // onStart: quoteyUpdatesRequested.type,
    // onSuccess: deleteQuoteyUpdateSuccess.type,
    // onError: quoteyUpdatesFailed.type,
  });

export const getDataForInsurerView = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/dataforstipdfscreen",
    method: "post",
    data: data,
    onStart: dataForInsurerViewInitialized.type,
    onSuccess: dataForInsurerViewSuccess.type,
    onError: dataForInsurerViewFailed.type,
  });

export const getDataForSTIpdfReady = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/getprospectdocforstipdfready",
    method: "post",
    data: data,
    onStart: dataForStiPDFreadyInitialized.type,
    onSuccess: dataForStiPDFreadySuccess.type,
    onError: dataForStiPDFreadyFailed.type,
  });

// For Jira
export const postToJira = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/jira/jira-post",
    method: "post",
    data: data,
    onStart: recentJiraInitiated.type,
    onSuccess: recentJiraSuccess.type,
    onError: recentJiraFailed.type,
  });

//+++++++++++++++++++++++ Selectors

export const getLoginModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isLoginModalOpen
);
export const getGoToMarket = createSelector(
  (state) => state.entities.components,
  (components) => components.isgoToMarket
);
export const getBindExternal = createSelector(
  (state) => state?.entities?.components,
  (components) => components?.gettingBindExternal
);
export const getSignUpModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isSignUpModalOpen
);
export const getConformationModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isConformationModalOpen
);
export const getBugModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isBugModalOpen
);

export const getSuccessStatusModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isSuccessStatusModalOpen
);

export const getAutoreminderState = createSelector(
  (state) => state.entities.components,
  (components) => components.autoreminder
);

export const getErrorStatusModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isErrorStatusModalOpen
);

export const getAddressModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isAddressModalOpen
);
export const getBindModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isBindModalOpen
);

export const getQuoteyUpdates = createSelector(
  (state) => state.entities.components,
  (components) => components.quoteyUpdates
);

export const getBindQuoteConformationModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isBindQuoteConformationModalOpen
);

export const isBinderLetterModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isBinderLetterModalOpen
);

export const getCertificateModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isCertificateModalOpen
);
export const getCreateReminderModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isCreateReminderModalOpen
);
export const getOtherStatusModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isOtherStatusModalOpen
);
export const getCertificateHolderModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isCertificateHolderModalOpen
);
export const getAdditionalModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isAdditionalModalOpen
);

export const getTransactionModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isTransactionModalOpen
);

export const getReminderModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isReminderModalOpen
);

export const getBinderStatus = createSelector(
  (state) => state.entities.components,
  (components) => components.gettingBindPdf
);

export const getDnDModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isDnDModalOpen
);

export const getClientHandOffModalState = createSelector(
  (state) => state.entities.components,
  (components) => components.isClientHandOffModalOpen
);

export const getShowHelpOrTip = createSelector(
  (state) => state.entities.components,
  (components) => components.showHelpOrTip
);

export const getHelpOrTipText = createSelector(
  (state) => state.entities.components,
  (components) => components.helpOrTipText
);

export const getLanguageCode = createSelector(
  (state) => state.entities.components,
  (components) => components.languagecode
);

export const getShowRecentQuotesTable = createSelector(
  (state) => state.entities.components,
  (components) => components.showRecentQuotesTable
);

export const getQFuserMode = createSelector(
  (state) => state.entities.components,
  (components) => components.questionFlowUserMode
);

export const getQAreaScrollThickness = createSelector(
  (state) => state.entities.components,
  (components) => components.qAreaScrollThickness
);

export const getRecentQuotesArray = createSelector(
  (state) => state.entities.components,
  (components) => components.recentquotes
);

export const getJiraStatus = createSelector(
  (state) => state.entities.components,
  (components) => components.jira
);

export const getDataForInsurerViewData = createSelector(
  (state) => state.entities.components,
  (components) => components.dataforInsurerView
);

export const getDoNotShowNavigationButtons = createSelector(
  (state) => state.entities.components,
  (components) => components.doNotShowNavigationButtons
);

export const getShowActualSTIpdf = createSelector(
  (state) => state.entities.components,
  (components) => components.showActualSTIpdf
);

export const getShowNavigationBar = createSelector(
  (state) => state.entities.components,
  (components) => components.showNavigationBar
);

export const getDocFromComponents = createSelector(
  (state) => state.entities.components,
  (components) => components.doc
);

export const getFormstateFromComponents = createSelector(
  (state) => state.entities.components,
  (components) => components.formstate
);
export const getFormsOrderFromComponents = createSelector(
  (state) => state.entities.components,
  (components) => components.formsorder
);
export const getFormGroupNodesArray = createSelector(
  (state) => state.entities.components,
  (components) => components.formGroupNodesArray
);
export const getPagesProperties = createSelector(
  (state) => state.entities.components,
  (components) => components.pages
);
export const getClientDetails = createSelector(
  (state) => state.entities.components,
  (components) => components.clientDetails
);
export const getBrokerDetails = createSelector(
  (state) => state.entities.components,
  (components) => components.brokerdetails
);
export const getUserDetails = createSelector(
  (state) => state.entities.components,
  (components) => components.userdetails
);
export const getPDFstatus = createSelector(
  (state) => state.entities.components,
  (components) => components.gettingPdf
);
export const getClientPDFstatus = createSelector(
  (state) => state.entities.components,
  (components) => components.gettingClientPdf
);
export const getCurrentFileContent = createSelector(
  (state) => state.entities.components,
  (components) => components.currentblobcontent
);
export const getNavigationPageStatus =
  ({ pagecode }) =>
  (state) =>
    state.entities.components.navigationActivation[pagecode];

export const getPDFV2status = createSelector(
  (state) => state.entities.components,
  (components) => components.gettingPdfv2
);
export const getPDFOnlyStatus = createSelector(
  (state) => state.entities.components,
  (components) => components.gettingPdfOnly
);

export const getBinderLetterStatus = createSelector(
  (state) => state.entities.components,
  (components) => components.gettingBindLetterPdf
);
